import { Location } from "@angular/common";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { IDGenerator } from "../../../../src/app/@core/utils/id-generator.util";
import { AppLocalStorage } from "../../../../src/app/@core/utils/local-storage.util";
import { environment } from "../../../../src/environments/environment";
import { ApiResponse, Subscriptions } from "../../@core/utils/common.model";
import { AppError } from "../error/error.model";
import { Store } from "../store/store";
import {
  AuthTokenResponse,
  LoginCredentials,
  LogoutResponse,
  Session,
  SessionAccount,
  SessionAccountResponse,
  UserConfig,
} from "./session.model";
import {
  LogoutErrorState,
  LogoutLoadedState,
  LogoutLoadingState,
  profileDataLoadedState,
  profileDataLoadingErrorState,
  profileDataLoadingState,
  profileImageLoadedState,
  profileImageLoadingErrorState,
  profileImageLoadingState,
  SessionCreatingErrorState,
  SessionCreatingState,
} from "./session.state";
import { MsalService } from "@azure/msal-angular";
import { AuthenticationResult } from "@azure/msal-browser";
import { resolve } from "dns";
 
@Injectable({
  providedIn: "root",
})
export class SessionService extends Store.AbstractService {
  private platformSubject: BehaviorSubject<string> =
    new BehaviorSubject<string>("");
  // private platformSubject: Subject<string> = new Subject<string>();
 
  private static RESTRICTED_REDIRECT_URLS: string[] = [
    "/loading",
    "/login",
    "/logout",
  ];
 
  defaultUserConfig: UserConfig = {
    widgetOrder: [],
    profile: {
      id: "",
      employeeId: "",
      employeeName: "",
      profileImg: null,
      email: "",
      mobileNumber: "",
      theme: null,
      language: null,
      location: null,
      notificationsEnabled: false,
    },
    favouriteApps: [],
    recentlyVisitedApps: [],
    clockOrder: [],
  };
 
  // sessionValidityTimer: NodeJS.Timer;
  sessionValidityTimer: any;
  private redirectURL: string;
  private redirectToken: string;
  session: Session;
  account: SessionAccount;
  tabSessionId: string;
  data: any;
 
  private redirectURLParams: string;
  private userConfigData = new BehaviorSubject<any>(
    this.defaultUserConfig
  );
  readonly userConfigData$ = this.userConfigData.asObservable();
 
  private profileDataLoaded = new BehaviorSubject<any>(null);
  readonly profileDataLoaded$ = this.profileDataLoaded.asObservable();

  private callLoadUserConfigApi = new Subject<any>();
  readonly callLoadUserConfigApi$ = this.callLoadUserConfigApi.asObservable();
 
  private subscriptions: Subscriptions = {
    sessionValidate: null,
  };
 
  constructor(
    private router: Router,
    private location: Location, // private snackBar: SnackBarService
    private msalService: MsalService
  ) {
    super();
  }
 
  init() {
    const me = this;
 
    // const account = this.msalService.instance.getActiveAccount();
    // if(account){
 
    //   me.setRedirectURL();
    //   // return
    // }
    me.setRedirectURL();
 
    return new Promise<void>((resolve, reject) => {
      me.initSession(resolve, reject);
    });
  }
 
  triggerLoadUserConfigAPI(source: any) {
    const me = this;
    me.account['favouriteApps'] = source;
    AppLocalStorage.set("ACCOUNT_DATA", "ACCOUNT_DATA", me.account);
    me.callLoadUserConfigApi.next(source);
  }
 
  redirectToLoginPage() {
    const me = this;
    // me.setRedirectURL();
    // me.router.navigate(["login"]);
  }
 
  redirectToHomePage() {
    const me = this;
    let redirectTo = "/home";
    if (me.redirectURL) {
      redirectTo = me.redirectURL;
      me.redirectToken = null;
    }
 
    // me.router.navigate([redirectTo]);
 
    me.router.navigate([redirectTo], {
      queryParams: me.queryStringToJSON(me.redirectURLParams),
    });
  }
 
  private queryStringToJSON(qs) {
    if (qs) {
      var pairs = qs.split("&");
      var result = {};
      pairs.forEach(function (pair) {
        pair = pair.split("=");
        result[pair[0]] = decodeURIComponent(pair[1] || "");
      });
      return result;
    }
  }
 
  private setRedirectURL(url?: string) {
    const me = this;
    const sessionInfo = localStorage.getItem("SESSION");
    let redirectURL: string = url;
    if (sessionInfo) {
      redirectURL = url || me.location.path().split("?")[0];
 
      me.redirectURLParams = me.location.path().split("?")[1];
    }
 
    me.redirectToken = IDGenerator.newId();
 
    if (SessionService.RESTRICTED_REDIRECT_URLS.indexOf(redirectURL) !== -1) {
      redirectURL = null;
    }
 
    me.redirectURL = redirectURL;
  }
 
  public login(credentials: LoginCredentials): Observable<Store.State> {
    const me = this;
    const output = new Subject<Store.State>();
 
    setTimeout(() => {
      output.next(new SessionCreatingState());
    }, 0);
 
    me.controller
      .post<ApiResponse<AuthTokenResponse>>(
        environment.api.session.login.endpoint,
        credentials
      )
      .subscribe(
        (data: ApiResponse<AuthTokenResponse>) => {
          if (data) {
            me.session = {
              token: data.data.jwt,
              id: IDGenerator.newId(),
              expiry: new Date(),
            };
 
            AppLocalStorage.set("SESSION", "SESSION", me.session);
 
            // me.redirectToHomePage();
 
            output.complete();
          } else {
            // me.snackBar.openSnackBar(data.message, 3000);
            setTimeout(() => {
              output.error(
                new SessionCreatingErrorState(new AppError("No Token Received"))
              );
              output.complete();
            }, 0);
          }
        },
        (e: any) => {
          setTimeout(() => {
            output.error(new SessionCreatingErrorState(e.error));
            output.complete();
          }, 0);
        }
      );
 
    return output;
  }
 
  public logout(): Observable<Store.State> {
    const me = this;
    const output = new Subject<Store.State>();
 
    setTimeout(() => {
      output.next(new LogoutLoadingState());
    }, 0);
 
    me.controller
      .get(environment.api.session.logout.endpoint, null, undefined, {
        Authorization: true,
      })
      .subscribe(
        (data: LogoutResponse) => {
          if (data) {
            output.next(new LogoutLoadedState(data));
            output.complete();
          }
        },
        (e: Error) => {
          setTimeout(() => {
            output.error(new LogoutErrorState(AppError.fromError(e)));
            output.complete();
          }, 0);
        }
      );
 
    return output;
  }
 
  // private loadAccount(): Observable<void> {
  // }
 
  // RolePermission[]
  // public getRolePermissionsFor(code: string): any[] {
  //   const me = this;
  //   if (me.account && me.account.permissions && me.account.permissions[code]) {
  //     return Object.values(me.account.permissions[code]);
  //   }
  //   return null;
  // }
 
  private startSessionValidation() {
    const me = this;
    me.stopSessionValidation();
    me.sessionValidityTimer = setTimeout(() => {
      me.validateSession();
    }, 60000);
  }
 
  private stopSessionValidation() {
    const me = this;
    if (me.sessionValidityTimer) {
      clearTimeout(me.sessionValidityTimer);
    }
  }
 
  private validateSession() {
    const me = this;
    const path = environment.api.auth.validate.endpoint;
    me.controller.get(path, null, undefined, { Authorization: true }).subscribe(
      (data: any) => {
        me.startSessionValidation();
      },
      (e: any) => {
        me.router.navigate(["logout"]);
      }
    );
  }
 
  private initSession(resolve: () => void, reject: (reason: AppError) => void) {
    const me = this;
 
    // const account = this.msalService.instance.getActiveAccount();
    //     if(!account){
    // this.redirectToLoginPage();
    // resolve();
    //       return
    //     }
 
    const session: Session = AppLocalStorage.get(
      "SESSION",
      "SESSION"
    ) as Session;
 
    if (me.isSessionActive(session)) {
      me.session = session;
 
      // me.redirectToHomePage();
      // resolve();
 
      me.loadAccount().subscribe(
        () => {
          resolve();
          // me.redirectToHomePage();
          // me.validateSession();
          // me.redirectToHomePage();
        },
        (error) => {
          reject(new AppError(error));
        }
      );
      return;
    } else {
      localStorage.clear();
      me.redirectToLoginPage();
      resolve();
    }
  }
 
  // loadUserConfig(accountData?:any, actionFrom?: string) {
 
  //   const me = this;
  //   const output = new Subject<any>();
  //   if (actionFrom !== "favouriteApps") {
  //     me.userConfigData.next(accountData["data"]);
  //   }
 
 
  //   const path = me.controller.replaceVariables(
  //     environment.api.session.loadUserConfiguration.endpoint,
  //     { employeeId }
  //   );
  //   me.controller.get(path, null, undefined, { Authorization: true }).subscribe(
  //     (data: UserConfig) => {
  //       if (data) {
  //         if (actionFrom !== "favouriteApps") {
  //           me.userConfigData.next(data["data"]);
  //         }
  //         subject.next();
  //         subject.complete();
 
  //         output.next(data);
  //         output.complete();
  //         me.fetchProfileData(me.account?.profile?.email);
  //         // me.redirectToHomePage();
  //       }
  //     },
  //     (e: any) => {
  //       output.error(new Error("Failed to Load Account"));
  //       output.complete();
  //     }
  //   );
 
  //   return output;
  // }
 
  public loadAccount(): Observable<void> {
    const me = this;
    const output = new Subject<void>();
    const path = environment.api.auth.me.endpoint;
    me.controller
      .get(path, null, undefined, {
        Authorization: true,
      })
      .subscribe(
        (data: SessionAccountResponse) => {
          me.account = data?.data;
          const employeeId = data?.data?.profile?.employeeId;
          AppLocalStorage.set("ACCOUNT_DATA", "ACCOUNT_DATA", me.account);
 
          me.callLoadUserConfigApi.next(me.account['favouriteApps']);
          // me.loadUserConfig(me.account);
          me.userConfigData.next(me.account);
          me.fetchProfileData( me.account?.profile?.email);
          output.next();
          output.complete();
        },
        (e: any) => {
          output.error(new Error("Failed to Load Account"));
          output.complete();
        }
      );
    return output;
  }
 
  public isActive(): boolean {
    return this.isSessionActive(this.session);
  }
 
  public clear(): Observable<void> {
    const output = new Subject<void>();
    const me = this;
 
    // Clear local storage
    // AppLocalStorage.clear("SESSION", "SESSION");
    localStorage.clear();
 
    // Stop session validation check
    me.stopSessionValidation();
 
    // CometChat LogOut
 
    // Reset Session
    me.session = null;
 
    setTimeout(() => {
      output.next();
    });
 
    return output;
  }
 
  private isSessionActive(session: Session): boolean {
    return !!session;
  }
 
  updatePlatform(platform: string) {
    this.platformSubject.next(platform);
  }
 
  getPlatform() {
    return this.platformSubject.asObservable();
  }
 
  fetchProfileData(empId) {
    const me = this;
    const output = new Subject<Store.State>();
    setTimeout(() => {
      output.next(new profileDataLoadingState());
    }, 0);
 
    const path = me.controller.replaceVariables(
      environment.api.profile.userProfile.endpoint,
      { empId }
    );
 
    me.controller.get(path, null, undefined, { Authorization: true }).subscribe(
      (data: any) => {
        AppLocalStorage.set("PROFILE_DATA", "PROFILE_DATA", data.data);
        this.profileDataLoaded.next(data.data);
        // This makes the second, corrected announcement with the complete profile.
        me.userConfigData.next(me.account);

        output.complete();
        // setTimeout(() => {
        // me.redirectToHomePage();
        // }, 100);
      },
      (e: any) => {
        output.error(new profileDataLoadingErrorState(e));
        output.complete();
      }
    );
    return output;
  }
 
 
  // getProfileImage(employeeId: any): any {
  //   const me = this;
  //   const output = new Subject<Store.State>();
  //   setTimeout(() => {
  //     output.next(new profileImageLoadingState());
  //   }, 0);
 
  //   const path = environment.api.myteam.getProfileImage.endpoint;
  //   me.controller
  //     .post(path, employeeId, undefined, { Authorization: true })
  //     .subscribe(
  //       (data: any) => {
  //         AppLocalStorage.set("PROFILE_IMAGE", "PROFILE_IMAGE"+String(employeeId).toLowerCase(), data.data);
  //         output.next(new profileImageLoadedState(data));
  //         output.complete();
  //       },
  //       (e: any) => {
  //         output.error(new profileImageLoadingErrorState(e));
  //         output.complete();
  //       }
  //     );
  //   return output;    
  // }
 
  private profileImageRequests = new Map<string, Subject<Store.State>>();

getProfileImage(employeeId: any): any {
  const cacheKey = "PROFILE_IMAGE_" + String(employeeId).toLowerCase();

  // Reuse existing in-flight request
  if (this.profileImageRequests.has(cacheKey)) {
    return this.profileImageRequests.get(cacheKey);
  }

  const output = new Subject<Store.State>();
  this.profileImageRequests.set(cacheKey, output);

  // Emit loading state
  setTimeout(() => {
    output.next(new profileImageLoadingState());
  }, 0);

  //Try cache first
  const cached = AppLocalStorage.get("PROFILE_IMAGE", cacheKey);
  if (cached) {
    output.next(new profileImageLoadedState({ data: cached }));
  }

  //Always refresh from API (auto-fix stale cache)
  const path = environment.api.myteam.getProfileImage.endpoint;

  this.controller
    .post(path, employeeId, undefined, { Authorization: true })
    .subscribe(
      (data: any) => {
        if (data?.data?.length) {
          AppLocalStorage.set("PROFILE_IMAGE", cacheKey, data.data);
          output.next(new profileImageLoadedState(data));
        }
        output.complete();
        this.profileImageRequests.delete(cacheKey);
      },
      (e: any) => {
        output.error(new profileImageLoadingErrorState(e));
        output.complete();
        this.profileImageRequests.delete(cacheKey);
      }
    );

  return output;
}



  // public currentSelectedPlatform = this.platformSubject.asObservable();
 
  // sendData(value: string) {
  //   this.platformSubject.next(value);
  // }
}
 
 